import { Container, Grid } from '@material-ui/core';
import { Box } from '@mui/material';
import React from 'react';
import { LabelWithBackLine } from '../../../../components/LabelWithBackLine';
import { BancosCadastradosListing } from './BancosCadastrados/BancosCadastradosListing';
import { ClassesProcessuaisListing } from './ClassesProcessuais/ClassesProcessuaisListing';
import { ConfigForm } from './ConfigForm';

export const ConfigProjudi = () => {
  return (
    <>
      <Container
        style={{
          boxShadow: 'none',
          padding: 0,
        }}
        maxWidth="xl"
      >
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            style={{
              boxShadow: 'none',
              width: '100%',
            }}
          >
            <LabelWithBackLine>Configurações</LabelWithBackLine>
            <Box
              display="flex"
              alignItems="center"
              style={{
                padding: 0,
                marginTop: '35px',
                width: '100%',
                marginBottom: '35px',
              }}
              boxShadow="none"
            >
              <ConfigForm />
            </Box>
          </Grid>
        </Grid>
      </Container>

      <BancosCadastradosListing />
      <ClassesProcessuaisListing />
    </>
  );
};
